import { Form, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../Liracrypt/liracrypt';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
const ColorDropdown = ({
    name,
    label,
    form,
    defaultValue,
    placeholder,
    disabled,
    labelSpan,
    labelCol,
    required,
    options,
    multiSelect,
    errorMessage,
    searchable,
    src = 'data',
    api,
    params
}) => {
    const [dropOptions, setDropOptions] = useState();
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);

    const getDropdownData = () => {
        liracrypt.get(api, { ...searchParams, ...params })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setDropOptions(data.data);
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
            })
    }

    useEffect(() => {
        if (src === 'api') {
            getDropdownData();
        } else {
            setDropOptions(options);
            setLoading(false);
        }
        if (defaultValue) {
            form.setFieldValue(name, defaultValue);
        }
    }, []);

    return (
        <Form.Item
            name={name}
            wrapperCol={!label ? { span: 24 } : undefined}
            labelCol={{ span: labelCol || labelSpan || 8 }}
            label={label}
            placeholder={placeholder}
            rules={[{ required: required, message: errorMessage }]}
        >
            <Select
                disabled={disabled}
                placeholder={placeholder}
                loading={loading}
                optionLabelProp="label"
                showSearch={searchable ? searchable : false}
                mode={multiSelect ? 'multiple' : undefined}
            >
                {
                    dropOptions?.length ?
                        dropOptions.map((x, i) => (
                            <Select.Option key={`color_dropdown_${name}_${i}`} value={x.value} label={x.label}>
                                <div
                                    style={{
                                        borderLeft: "5px solid",
                                        borderColor: x.colr,
                                        paddingLeft: "10px",
                                    }}
                                >
                                    {x.label}
                                </div>
                            </Select.Option>
                        )) : <></>
                }
            </Select>
        </Form.Item>
    )
};

export default ColorDropdown;